import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c38cfc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-hover" }
const _hoisted_2 = { class: "table-head" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "btn-box" }
const _hoisted_5 = ["disabled"]

import { PropType, ref, computed } from 'vue'
	import { Device } from '@/interface/device'
	import Loading from 'vue3-loading-overlay'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		header: {
			type: Array as PropType<any[]>,
			default: () => [],
		},
		item: {
			type: Array as PropType<any[]>,
			default: () => [],
		},
		height: {
			type: Number,
			default: 0,
		},
	},
  emits: ['deleteItem'],
  setup(__props, { emit }) {

const props = __props

	

	const loadings = computed(() => {
		if (props.item[0]) {
			return false
		} else {
			return true
		}
	})

	

	const pick = ref([] as Device[])

	const pickCheck = computed(() => {
		if (pick.value.length === 1) {
			return false
		} else {
			return true
		}
	})

	const selectItem = (item: Device) => {
		const lengthCheck = pick.value.length === 1
		const itemCheck = pick.value.includes(item)
		if (itemCheck) {
			pick.value.pop()
			return
		}
		if (lengthCheck) {
			pick.value.pop()
			pick.value.push(item)
			return
		} else {
			pick.value.push(item)
			return
		}
	}
	const deleteSuccess = async () => {
		pick.value = []
	}
	const deleteItem = async () => {
		emit('deleteItem', pick.value)
		await deleteSuccess()
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "scroll-bar-del",
      style: _normalizeStyle([{"overflow-y":"auto"}, { maxHeight: `${props.height}%` }])
    }, [
      _createVNode(_unref(Loading), {
        active: _unref(loadings),
        "is-full-page": false,
        "background-color": "#2b323a",
        color: "#8c98a5",
        opacity: 0.8
      }, null, 8, ["active", "opacity"]),
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.header, (val, idx) => {
              return (_openBlock(), _createElementBlock("th", {
                class: "admin-super-th",
                scope: "col",
                key: idx
              }, _toDisplayString(val.label), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item, (val, idx) => {
            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val, (val2, idx2) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: _normalizeClass(["admin-super-td", {
							tableActive: pick.value.includes(val),
						}]),
                  key: idx2,
                  onClick: ($event: any) => (selectItem(val))
                }, _toDisplayString(val2), 11, _hoisted_3))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "del-btn",
        disabled: _unref(pickCheck),
        onClick: deleteItem
      }, _toDisplayString(_ctx.$t('delete')), 9, _hoisted_5)
    ])
  ], 64))
}
}

})